import { initMfes } from "@cw-elements/mfe-setup/init";
const MFE_ENDPOINT = process.env.REACT_APP_MFE_ENDPOINT ?? "";

(async () => {
  await initMfes({
    "cw-machinery-button": `${MFE_ENDPOINT}/cw-machinery-button`,
    "entities-hall": `${MFE_ENDPOINT}/entities-hall`,
    "topbar-navigation": `${MFE_ENDPOINT}/topbar-navigation`,
    "machinery-field-operations": `${MFE_ENDPOINT}/machinery-field-operations`,
    "connect-files": `${MFE_ENDPOINT}/connect-files`,
  });
  await import("./index");
})().catch((error) => {
  console.error("Error initiating MFEs:", error);
});
